export const ShopCard = ({ p, base }) => {
  const fv = p.founder_places?.length || 0;
  return (
    <div data-testid="preview-shop-card" className="w-full max-w-[340px] bg-white border border-[#e6dfd4] font-[Georgia,serif] shadow-sm">
      <div className="relative">
        {p.has_cover ? <img src={`${base}/cover`} alt={p.title} className="w-full aspect-[4/3] object-cover" />
          : <div className="w-full aspect-[4/3] bg-[#efe9df]" />}
        {p.collection === "founders" && <span className="absolute top-3 right-3 bg-[#C9A847] text-white text-[11px] tracking-[0.12em] uppercase px-2.5 py-1.5 font-[Arial,sans-serif]">✦ {fv ? `${fv} Founder Verified places` : "Founder Verified"}</span>}
      </div>
      <div className="p-5">
        <h3 className="text-lg text-[#2B2A26] leading-snug">{p.title}</h3>
        <div className="text-sm text-[#8a8076] mt-1">{p.subtitle}</div>
        {fv > 0 && <div className="text-xs text-[#9A7B2C] mt-2 font-[Arial,sans-serif]">✦ I’ve been to: {p.founder_places.slice(0, 4).join(", ")}{fv > 4 ? ` + ${fv - 4} more` : ""}</div>}
        <div className="text-[15px] text-[#2B2A26] mt-3 font-[Arial,sans-serif]">${p.price} {p.currency}</div>
        <span className="mt-4 inline-block bg-[#2B2A26] text-white text-xs tracking-[0.16em] uppercase px-5 py-3 font-[Arial,sans-serif] opacity-80 cursor-not-allowed" title="Preview only">Buy this kit</span>
      </div>
    </div>
  );
};
